module.exports = __webpack_public_path__ + "img/19_76.0d434aea.png";